// extracted by mini-css-extract-plugin
export var headerCell = "_3p-1";
export var loadingSpinnerContainer = "_3p-4";
export var rowWrapper = "_3p-3";
export var standaloneTable = "_3p-5";
export var table = "_3p-0";
export var white = "_3p-2";